import React, { useState, useContext } from "react";
import { Link, withRouter } from "react-router-dom";
import { Icon, notification } from "antd";
import UserInfo from "../UserInfo/UserInfo";
import Tabela from "./Tabela";
import ModalLoading from "../../../shared/components/Modals/ModalLoading";
import ModalViewer from "../../../shared/components/Modals/ModalViewer";
import { GlobalContext } from "../../../app/providers/GlobalState";
import axios from "axios";

import { descarregar } from "../../../assets/menu";

const openNotificationWithIcon = (type, message, description) => {
    notification[type]({
        message: message,
        description: description
    });
};

const Documentos = ({ menuOptionSelected, match }) => {
    const globalContext = useContext(GlobalContext);
    const [visibleLoading, setVisibleLoading] = useState(false);
    const [visibleViewer, setVisibleViewer] = useState(false);
    const [activated, setActivated] = useState(true);
    const [search, setSearch] = useState("");
    const [docs, setDocs] = useState([]);

    const gerarDoc = () => {
        setVisibleLoading(true);

        const params = {
            ano: globalContext[`ano${match.params.code}`],
            entidade: localStorage.getItem("entidade_id")
        };

        if (search !== null && search !== undefined && search !== "") {
            params.pesquisa = search;
        }

        axios({
            method: "get",
            url: "/api/pdf/dados-gerais-documentacao",
            params
        })
            .then(response => {
                setVisibleLoading(false);
                setVisibleViewer(true);

                setDocs([{ uri: response.data }]);
            })
            .catch(() => {
                openNotificationWithIcon("error", "Erro", "Não foi possível gerar documento!");
                setVisibleLoading(false);
            });
    };

    const carregarAnosDocumentos = () => {
        axios({
            method: "get",
            url: "/api/user-detalhe/carregar-anos-documentos"
        })
            .then(response => {
                globalContext.atualizarState({
                    [`listaAnos${match.params.code}`]: response.data
                });

                // Define "Todos" como ano selecionado por defeito
                globalContext.atualizarState({
                    [`ano${match.params.code}`]: "Todos"
                });
            })
            .catch(error => {
                // Em caso de erro, ainda assim definimos a lista com "Todos"
                globalContext.atualizarState({
                    [`listaAnos${match.params.code}`]: ["Todos"],
                    [`ano${match.params.code}`]: "Todos"
                });
            });
    };

    const handleChangeSearch = value => {
        setSearch(value);
    };

    const resetSearch = () => {
        setActivated(true);
        setSearch("");
    };

    return (
        <div className="details-page" style={{ marginTop: "80px" }}>
            <div className="page-container" style={{ minHeight: "1000px" }}>
                <UserInfo
                    documentos
                    carregarAnosDocumentos={carregarAnosDocumentos}
                    search={search}
                    handleChangeSearch={handleChangeSearch}
                    resetSearch={resetSearch}
                    setActivated={setActivated}
                />
                <div className="user-info-detail ajustar-ecra-centro">
                    <div className="page-info">
                        <div>
                            <h1 className="page-title" style={{ margin: "20px 20px 10px 20px" }}>
                                Documentação
                            </h1>
                        </div>
                        <span className="page-controls">
                            <Link className="botao-descarregar" to="#" title="Descarregar" onClick={gerarDoc}>
                                <img src={descarregar} />
                                <span>Descarregar</span>
                            </Link>
                            <Link
                                to={"/utilizador"}
                                className="botao-secundario botao-secundario-redondo"
                                style={{ marginRight: 10, display: "flex", justifyContent: "center", alignItems: "center" }}
                            >
                                <Icon type="arrow-left" />
                            </Link>
                        </span>
                    </div>
                    <div className="block-table">
                        <Tabela
                            carregarAnosDocumentos={carregarAnosDocumentos}
                            search={search}
                            activated={activated}
                            setActivated={setActivated}
                        />
                    </div>
                </div>
                <ModalLoading visible={visibleLoading} text="A gerar documento..." />
                <ModalViewer visible={visibleViewer} docs={docs} onCancel={() => setVisibleViewer(false)} />
            </div>
        </div>
    );
};

export default withRouter(Documentos);
